import { useMemo } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import MetaTags from 'react-meta-tags';

export function Document() {
  const manifest = useMemo(
    () => ({
      short_name: 'Resultado Exames',
      name: `Resultado Exames - ${process.env.REACT_APP_NAME_LAB}`,
      icons: [
        {
          src: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH_LOGO}${process.env.REACT_APP_API_COD_BANCO}`,
          sizes: '64x64 32x32 24x24 16x16',
          type: 'image/x-icon',
        },
        {
          src: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH_LOGO}${process.env.REACT_APP_API_COD_BANCO}`,
          type: 'image/png',
          sizes: '192x192',
        },
        {
          src: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH_LOGO}${process.env.REACT_APP_API_COD_BANCO}`,
          type: 'image/png',
          sizes: '512x512',
          purpose: 'any maskable',
        },
      ],
      start_url: `${window.location.origin}/${process.env.REACT_APP_BASE_ROUTE}/`,
      display: 'standalone',
      theme_color: '#000000',
      scope: `${window.location.origin}/${process.env.REACT_APP_BASE_ROUTE}/`,
      background_color: '#ffffff',
    }),
    [],
  );

  const urlManifest = window.URL.createObjectURL(
    new Blob([JSON.stringify(manifest)], { type: 'application/json' }),
  );

  return (
    <MetaTags>
      <title>
        {process.env.REACT_APP_NAME_LAB}
        {' '}
        - Resultados
      </title>
      <meta
        name="description"
        content={`Site de resultado de exames ${process.env.REACT_APP_NAME_LAB}`}
      />
      <base href={`/${process.env.REACT_APP_BASE_ROUTE}`} />
      <link
        rel="icon"
        href={`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH_LOGO}${process.env.REACT_APP_API_COD_BANCO}`}
      />
      <link
        rel="apple-touch-icon"
        href={`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH_LOGO}${process.env.REACT_APP_API_COD_BANCO}`}
      />
      <link rel="manifest" href={urlManifest} />
    </MetaTags>
  );
}
